import { CancelBookingSummaryModel } from '@/__generated';
import Spin from '@/components/Spin';
import { BookingStatus, PaymentStatus } from '@/constants';
import { handleApiUnKnowError } from '@/helpers/errorHandle';
import { formatPriceWithCurrency } from '@/hooks/useCurrencyFormat';
import { apiSdk } from '@/httpClient';
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { HOTEL_CONFIG } from '@/config';
import { ModalUtils } from '@/contexts/ModalWrapper';
import { AppUrls } from '@/urls';
import { useHistory } from 'react-router-dom';
import bookingService from '@/services/bookingService';

type Props = {
  bookingId: string;
  onCloseModal: (reload?: boolean) => void;
};

export default function CancelBookingModal({ bookingId, onCloseModal }: Props) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [cancelBookingSummary, setCancelBookingSummary] = React.useState<CancelBookingSummaryModel>();
  const history = useHistory();

  React.useEffect(() => {
    if (bookingId) {
      getBookingDetail();
    }
  }, [bookingId]);
  const getBookingDetail = () => {
    setLoading(true);

    apiSdk.AgentBookingService.getCancelBookingSummary({ bookingId: bookingId })
      .then(res => {
        if (res.success) {
          setCancelBookingSummary(res);
        } else {
          handleApiUnKnowError(res.message, onCloseModal);
        }
      })
      .catch(handleApiUnKnowError)
      .finally(() => setLoading(false));
  };
  const confirm = () => {
    setLoading(true);
    apiSdk.AgentBookingService.cancelBooking({
      body: {
        bookingId: bookingId,
        cancellationFee: cancelBookingSummary?.booking?.cancellationFee || 0,
      },
    })
      .then(res => {
        bookingService.handleCancelBookingResponse(bookingId, res, getBookingDetail);
      })
      .catch(handleApiUnKnowError)
      .finally(() => setLoading(false));
  };
  const hotelImage = React.useMemo(() => {
    return HOTEL_CONFIG.__getImageWithDefault(cancelBookingSummary?.booking?.images);
  }, [cancelBookingSummary]);

  let booking = cancelBookingSummary?.booking;
  const isOnHold = booking?.bookingStatus === BookingStatus.Hold;
  return (
    <Modal isOpen={true} unmountOnClose={true}>
      <ModalHeader>Booking Cancellation</ModalHeader>
      <Spin loading={loading}>
        <ModalBody>
          <div>
            <div className="mb-10 text-red-1 fw-500 text-18">Are you sure to cancel this booking?</div>

            <div className="row mb-10 x-gap-10">
              <div className="col-auto">
                <img className="size-50 rounded-4 object-cover" src={hotelImage} />
              </div>
              <div className="col">
                <div className="fw-500">{booking?.hotelName}</div>
              </div>
            </div>
            <div className=" row mb-10 x-gap-10">
              <div className="col-auto">Booking Status</div>
              <div className="col text-end fw-500">{BookingStatus.__getValue(booking?.bookingStatus)}</div>
            </div>
            <div className=" row mb-10 x-gap-10">
              <div className="col-auto">Payment Status</div>
              <div className="col text-end fw-500">{PaymentStatus.__getValue(booking?.paymentStatus)}</div>
            </div>

            <div className=" row mb-10 x-gap-10">
              <div className="col-auto">Cancellation Fee</div>
              <div className="col text-end fw-500">{formatPriceWithCurrency(booking?.cancellationFee, booking?.currency)}</div>
            </div>

            {/* {(booking?.refundAmount || 0) > 0 ? (
              <div className=" row mb-10 x-gap-10">
                <div className="col-auto">Refund amount</div>
                <div className="col text-end fw-500">{formatPriceWithCurrency(booking?.refundAmount, booking?.currency)}</div>
              </div>
            ) : null} */}
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button className="button px-15 bg-light-2 py-10" onClick={() => onCloseModal(false)}>
            <i className="icon-close text-12 px-5" />
            Close
          </button>
          <button className="button px-15 bg-red-1  py-10 text-white" onClick={confirm}>
            <i className="icon-check text-12 px-5" />
            Proceed to cancel
          </button>
        </ModalFooter>
      </Spin>
    </Modal>
  );
}
